<div *ngIf="isReimbursNew || isReimbursAssigned || isReimbursPaymentPending">
<div class="modal-header customBlueHeader" >
    <p class="modal-title" *ngIf="isReimbursNew">Mark Reimbursement as New</p>
    <p class="modal-title" *ngIf="isReimbursAssigned">Assign the claim</p>
    <!--<p class="modal-title" *ngIf="isReimbursRejected">Mark Reimbursement as Rejected</p>-->
    <p class="modal-title" *ngIf="isReimbursPaymentPending">Mark Reimbursement as Payment Pending</p>
    <button type="button" class="close" aria-label="Close" (click)="modelClose()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
  <div [ngClass]="{'succMsg': isSuccessMsg, 'errMsg': isFailureMsg}"><b>{{msg}}</b></div>
  <div class="modal-body customModalBody">
    <p *ngIf="isReimbursNew">Are you sure, you want to this reimbursement as new ?</p>
    <p *ngIf="isReimbursAssigned">Are you sure, you want to assign the claim ?</p>
    <!--<p *ngIf="isReimbursRejected">Are you sure, you want to this reimbursement as Rejected ?</p>-->
    <p *ngIf="isReimbursPaymentPending">Are you sure, you want to this reimbursement as Payment Pending Release ?</p>
  </div>
  <div class="modal-footer customModalFooter">
    <button type="button" class="btn danger_btn" (click)="modelClose()" *ngIf="!isReimbursAssigned">Cancel</button>
    <button type="button" class="btn green_btn" (click)="confirmReimburse()" *ngIf="!isReimbursAssigned">Confirm</button>
    <button type="button" class="btn danger_btn" (click)="modelClose()" *ngIf="isReimbursAssigned">No</button>
    <button type="button" class="btn green_btn" (click)="confirmReimburse()" *ngIf="isReimbursAssigned">Yes</button>
  </div>
</div>

<div *ngIf="isReimbursApproved">
<div class="modal-header customBlueHeader" >
    <p *ngIf="isReimbursApproved" class="modal-title">Mark Reimbursement as Approve</p>
    <button type="button" class="close" aria-label="Close" (click)="modelClose()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
  <div [ngClass]="{'succMsg': isSuccessMsg, 'errMsg': isFailureMsg}"><b>{{msg}}</b></div>
  <form [formGroup]="approval_Form">
  <div class="modal-body customModalBody">
      <div class="form-group">
        <label>Bill Amount</label>
        <input type="text" class="form-control" formControlName="billAmount" readonly >
      </div>
      <div class="form-group">
        <label>Claim Amount</label>
        <input type="text" class="form-control" formControlName="requestedAmount" readonly >
      </div>
      <div class="form-group">
        <label>Approve Amount</label>
        <input type="text" class="form-control" formControlName="approvedAmount"  >
      </div>
      <div class="form-group">
        <label>Remark</label>
        <textarea class="form-control col-form-label-sm " rows="3" formControlName="Remark"></textarea>
      </div>
  </div>
  <div class="modal-footer customModalFooter">
    <button type="button" class="btn danger_btn" (click)="modelClose()">Cancel</button>
    <button type="button" class="btn green_btn"  (click)="confirmReimburse()">Approve</button>
  </div>
  </form>
</div>


<div *ngIf="isReimbursPaid">
<div class="modal-header customBlueHeader" >
    <p *ngIf="isReimbursPaid" class="modal-title">Mark Reimbursement as Paid</p>
    <button type="button" class="close" aria-label="Close" (click)="modelClose()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
  <div [ngClass]="{'succMsg': isSuccessMsg, 'errMsg': isFailureMsg}"><b>{{msg}}</b></div>
  <form [formGroup]="approval_Form">
  <div class="modal-body customModalBody">
      <div class="form-group">
        <label>Requested Amount</label>
        <input type="text" class="form-control" formControlName="requestedAmount" readonly >
      </div>
      <div class="form-group">
        <label>Approve Amount</label>
        <input type="text" class="form-control" formControlName="approvedAmount"  readonly>
      </div>
      <div class="form-group">
        <label>Payment Reference Number</label>
        <input type="text" class="form-control" formControlName="paymentReferenceNumber" >
      </div>
      <div class="form-group">
        <label>Payment Transaction Date</label>
        <div class="input-group">
          <input class="form-control" [minDate]="minDate" [maxDate]="maxDate" #dp="bsDatepicker" bsDatepicker formControlName="selectDate"
          [bsConfig]="bsConfig">
         <div class="input-group-append">
           <button class="btn btn-primary" type="button" (click)="dp.toggle()"><i
            class="fa fa-calendar" aria-hidden="true"></i></button>
            </div>
        </div>
      </div>
  </div>
  <div class="modal-footer customModalFooter">
    <button type="button" class="btn danger_btn" (click)="modelClose()">Cancel</button>
    <button type="button" class="btn green_btn" (click)="confirmReimburse()">Confirm</button>
  </div>
  </form>
</div>

<div *ngIf="isReimbursRejected">
  <div class="modal-header customBlueHeader" >
      <button type="button" class="close" aria-label="Close" (click)="modelClose()">
        <span aria-hidden="true">&times;</span>
      </button>
  </div>
    <div [ngClass]="{'succMsg': isSuccessMsg, 'errMsg': isFailureMsg}"><b>{{msg}}</b></div>
    <form [formGroup]="approval_Form">
    <div class="modal-body customModalBody">
        <div class="form-group">
          <label>Remark</label>
          <textarea class="form-control"  rows="3" formControlName="Remark"></textarea>
        </div>
    </div>
    <div class="modal-footer customModalFooter">
      <button type="button" class="btn danger_btn" (click)="modelClose()">Cancel</button>
      <button type="button" class="btn green_btn" (click)="confirmReimburse()">Confirm</button>
    </div>
    </form>
  </div>